import { useAuth } from '../../context/auth-context';
import Emoji from '../../components/shared/Emoji'; 
import { Link, useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
import Button from '../../components/DynamicForm/Button';
import SeguroFormIndex from '../../components/DynamicForm/SeguroFormIndex';
import SeguroService from '../../services/seguro/seguro-service';
import React, { useState, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
// import { useDialog } from '../../context/dialog-context';
// import { DIALOG } from '../../constants/dialog/dialog';
import Loading from '../../components/shared/Loading';
import { useStep } from '../../context/step-context';
import { RETURN } from '../../constants/actions/buttons.constants';
import ConsultGeneral from '../../services/consult/consult-general';
import OpenCoopCrmService from '../../services/verification/open-coop-service';

import { Cache } from 'aws-amplify';

const SeguroForm = () => {
  const cacheCredit = Cache.getItem('requestCredit');
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  const [renderForm, setRenderForm] = useState(false);
  const [submit, setSubmit] = useState(0);
  const methods = useForm();
  // const dialog = useDialog();
  const navigate = useNavigate();
  
  const [formStudent, setFormStudent] = useState(false);
  const [formCodeudor1, setFormCodeudor1] = useState(false);
  const [formCodeudor2, setFormCodeudor2] = useState(false);
  
  const [edadStudent, setEdadStudent] = useState(false);
  const [edadCodeudor1, setEdadCodeudor1] = useState(false);
  const [edadCodeudor2, setEdadCodeudor2] = useState(false);

  const [financiarStudent, setFinanciarStudent] = useState(false);

  const [deudaStudentOpen, setDeudaStudentOpen] = useState(false);
  const [deudaCodeudor1Open, setDeudaCodeudor1Open] = useState(false);
  const [deudaCodeudor2Open, setDeudaCodeudor2Open] = useState(false);
  const [nameUser, setNameUser] = useState('');
  const [documentUser, setDocumentUser] = useState('');
  const [aceptedForm, setAceptedForm] = useState(false);
  const [loadingButton, setLoadingButton] = useState(true);

  
  
  const {
    step: { loanId },
  } = useStep();
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const checkFinancialBlockade = async (nro_identificacion) => {
    let deuda = false;
    const body = {
      nro_identificacion,
      rol: 'consultaOpenCreditosPantalla',
    };
    const resul = await OpenCoopCrmService.postOpenCoop(body);
    if (resul?.listCustomer?.length > 0) {
      let saldo = 0;
      
      resul?.listCustomer[0].forEach((item) => {
        saldo += item.saldo_total;
      });

      if (Number(saldo) >= process.env.REACT_APP_VALIDATE_VALUE_FINANCIAL_SEGURO) {
        deuda = true;
      }      
      return deuda;
    }
  };
  const checkConsultaCreditosCodeudor = async (nro_identificacion) => {
    let deuda = false;
    const body = {
      nro_identificacion,
      rol: 'consultaCreditosCodeudor',
    };
    const resul = await OpenCoopCrmService.postOpenCoop(body);
    if (resul?.listCustomer?.length > 0) {
      let saldo = 0;
      
      resul?.listCustomer[0].forEach((item) => {
        saldo += item.saldo_total;
      });

      if (Number(saldo) >= process.env.REACT_APP_VALIDATE_VALUE_FINANCIAL_SEGURO) {
        deuda = true;
      }      
      return deuda;
    }
  };

  const changeLegalizado = async () =>{
    const bodyHistoryAutomaticValidation = {
      creditId: cacheCredit.numero,
      rol: 'processApprovalPreAprobado'
    };
    await ConsultGeneral.postAutomate(bodyHistoryAutomaticValidation)
      .then(resp => {
        if (resp === '') {
          navigate('/solicitar-financiacion');
          window.location.reload();
        }
      })
    .catch((error) => {
      console.error(error);
    });
  };

  const checkGetSeguro = async (loanId, estudianteId = null, codeudorId = null) => {
    try {
      const payload = { loanId };
  
      if (estudianteId) {
        payload.estudianteId = estudianteId;
      } else if (codeudorId) {
        payload.codeudorId = codeudorId;
      }
  
      const response = await SeguroService.getSeguro(payload);
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
  
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      edad--;
    }
  
    return edad;
  };
  
  const fetchGetForm = async () => {
    const estudiante = await checkGetSeguro(loanId, cacheCredit.estudiante.id);

    //validar si estudiante ya respondio encuenta
    if (estudiante.estudianteId && typeof estudiante.estudianteId === 'string') {
      //setLoading(false);
      // Validar codeudor 1 existe
      if (cacheCredit?.codeudores[0]?.id !== undefined) {
      
        const codeudor1 = await checkGetSeguro(loanId ,null, cacheCredit?.codeudores[0]?.id);
        
        //valida si codeudor 1 respondio encuenta
        if (codeudor1.codeudorId && typeof codeudor1.codeudorId === 'string') {
         // setLoading(false);

          // Validar codeudor 1 existe
          if (cacheCredit?.codeudores[1]?.id !== undefined) {
          
            const codeudor2 = await checkGetSeguro(loanId ,null, cacheCredit?.codeudores[1]?.id);
             //valida si codeudor 2 respondio encuenta
            if (codeudor2.codeudorId && typeof codeudor2.codeudorId === 'string') {
             // setLoading(false);

            } else {
              // valida si esta en open con las caracteristicas y mostar encuenta
              const consultaOpenCreditosCodeudor = await checkConsultaCreditosCodeudor(cacheCredit?.codeudores[1]?.documento);
              const fechaNacimiento = calcularEdad(cacheCredit?.codeudores[1]?.fechaNacimiento);
    
              if (consultaOpenCreditosCodeudor || Number(fechaNacimiento) >= process.env.REACT_APP_VALIDATE_AGE_SEGURO ) {
                console.log(consultaOpenCreditosCodeudor);
                setEdadCodeudor2(fechaNacimiento);
                setDeudaCodeudor2Open(consultaOpenCreditosCodeudor);
                setFormCodeudor2(true);
                setAceptedForm(true);
                setRenderForm(true); 
                setLoading(false);
                return;
                
              } else {
                setFormCodeudor2(true);
                setLoading(false);
        
              }
            }
          } else {
            navigate('/solicitar-financiacion');
            window.location.reload();
          }
          
        } else {
          // valida si esta en open con las caracteristicas y mostar encuenta
          const consultaOpenCreditosCodeudor = await checkConsultaCreditosCodeudor(cacheCredit?.codeudores[0]?.documento);
          const fechaNacimiento = calcularEdad(cacheCredit?.codeudores[0]?.fechaNacimiento);
  
          if (consultaOpenCreditosCodeudor || Number(fechaNacimiento) >= process.env.REACT_APP_VALIDATE_AGE_SEGURO) {
            console.log(consultaOpenCreditosCodeudor);
            setEdadCodeudor1(fechaNacimiento);
            setDeudaCodeudor1Open(consultaOpenCreditosCodeudor);
            setFormCodeudor1(true);
            setAceptedForm(true);
            setRenderForm(true); 
            setLoading(false);
            return;
            
          } else {
            setFormCodeudor1(true);
            setLoading(false);
    
          }
        }
  
        
      } else {
        navigate('/solicitar-financiacion');
        window.location.reload();
      }
      
    } else {
      // valida si esta en open con las caracteristicas y mostar encuenta
      const fechaNacimiento = calcularEdad(cacheCredit.estudiante.fechaNacimiento);
      const consultaOpenCreditosPantalla = await checkFinancialBlockade(cacheCredit.estudiante.documento);

      console.log(fechaNacimiento);
      
      if (consultaOpenCreditosPantalla || Number(fechaNacimiento) >= process.env.REACT_APP_VALIDATE_AGE_SEGURO || Number(cacheCredit.valorFinanciar) >= process.env.REACT_APP_VALIDATE_VALUE_FINANCIAL_SEGURO ) {
        setEdadStudent(fechaNacimiento);
        setFinanciarStudent(cacheCredit.valorFinanciar);
        setDeudaStudentOpen(consultaOpenCreditosPantalla);
        setFormStudent(true);
        setAceptedForm(true);
        setRenderForm(true); 
        setLoading(false);
      } else {
        setFormStudent(true);
        setLoading(false);

      }
      
      
    }
    
  };

 

  
  const onSubmit = async (values) =>{
    setLoadingButton(false);
    let body = [];

    if (renderForm) {
      body = {
        acepto: aceptedForm ? 'Sí' : 'No',
        edad:edadStudent ? 'Sí' : edadCodeudor1 ? 'Sí' : edadCodeudor2 ? 'Sí' : 'No',
        financiacion:financiarStudent ? 'Sí' : 'No',
        deuda:deudaStudentOpen ? 'Sí' : deudaCodeudor1Open ? 'Sí' : deudaCodeudor2Open ? 'Sí' : 'No',
        peso: values.values.peso,
        estatura: values.values.estatura ,
        enfermedad: values.values.enfermedad === 'true' ? 'Sí' : 'No',
        vih: values.values.vih === 'true' ? 'Sí' : 'No',
        tratamiento: values.values.tratamiento === 'true' ? 'Sí' : 'No',
        discapacidad: values.values.discapacidad === 'true' ? 'Sí' : 'No',
        expuesta: values.values.expuesta === 'true' ? 'Sí' : 'No',
        expuestaPersona: values.values.expuestaPersona === 'true' ? 'Sí' : 'No',
        enfermedadCual: values.values.enfermedadCual,
        enfermedadAno: values.values.enfermedadAno,
        enfermedadMas: values.values.enfermedadMas,
        tratamientoCual: values.values.tratamientoCual,
        discapacidadCual: values.values.discapacidadCual,
        loanId,
        estudianteId: formStudent ? cacheCredit.estudiante.id : '',
        codeudorId: formCodeudor1 ? cacheCredit.codeudores[0].id : formCodeudor2 ? cacheCredit.codeudores[1].id: '',
      };
      
    } else {
      body = {
        acepto: renderForm ? 'Sí' : 'No',
        edad:edadStudent ? 'Sí' : edadCodeudor1 ? 'Sí' : edadCodeudor2 ? 'Sí' : 'No',
        financiacion:financiarStudent ? 'Sí' : 'No',
        deuda:deudaStudentOpen ? 'Sí' : deudaCodeudor1Open ? 'Sí' : deudaCodeudor2Open ? 'Sí' : 'No',
        peso: values?.values?.peso,
        estatura: values?.values?.estatura,
        enfermedad: values?.values?.enfermedad,
        vih: values?.values?.vih,
        tratamiento: values?.values?.tratamiento,
        discapacidad: values?.values?.discapacidad,
        expuesta: values?.values?.expuesta,
        expuestaPersona: values?.values?.expuestaPersona,
        enfermedadCual: values?.values?.enfermedadCual,
        enfermedadAno: values?.values?.enfermedadAno,
        enfermedadMas: values?.values?.enfermedadMas,
        tratamientoCual: values?.values?.tratamientoCual,
        discapacidadCual: values?.values?.discapacidadCual,
        loanId,
        estudianteId: formStudent ? cacheCredit.estudiante.id : '',
        codeudorId: formCodeudor1 ? cacheCredit.codeudores[0].id : formCodeudor2 ? cacheCredit.codeudores[1].id: '',
      };
    }

    let shouldReload = true;
  let shouldChangeLegalizado = false;


    await SeguroService.seguroPost(body)
    .then(async () => {
      const codeudoresTotal = cacheCredit.codeudores.length;
      
      if (codeudoresTotal > 0) {
        if (formStudent) {
          // Solo recargar, no legalizar
          shouldReload = true;
          shouldChangeLegalizado = false;
        } else if (codeudoresTotal === 1) {
          // Legalizar, no recargar
          shouldReload = false;
          shouldChangeLegalizado = true;
        } else if (codeudoresTotal === 2) {
          if (formCodeudor1) {
            // Solo recargar, no legalizar
            shouldReload = true;
            shouldChangeLegalizado = false;
          } else if (formCodeudor2) {
            // Legalizar, no recargar
            shouldReload = false;
            shouldChangeLegalizado = true;
          }
        }
      } else {
        // No hay codeudores, legalizar
        shouldReload = false;
        shouldChangeLegalizado = true;
      }
      
      // Ejecutar las acciones al final, no durante el flujo
      if (shouldChangeLegalizado) {
        await changeLegalizado();
      } else if (shouldReload) {
        window.location.reload();
      }
    })
    .catch((error) => {
      console.error(error);
    });
    // navigate('./confirmacion');
  };

  const getNombreCompleto = () => {
    if (formStudent) {
      return[ `${cacheCredit.estudiante.nombre} ${cacheCredit.estudiante.apellido}`, cacheCredit.estudiante.documento];
    } else if (formCodeudor1) {
      return [`${cacheCredit.codeudores[0].nombre} ${cacheCredit.codeudores[0].apellido}`, cacheCredit.codeudores[0].documento];
    } else if (formCodeudor2) {
      return [`${cacheCredit.codeudores[1].nombre} ${cacheCredit.codeudores[1].apellido}`, cacheCredit.codeudores[1].documento];
    } else {
      return null;
    }
  };
  // const fetchSeguro = () =>
  //   SeguroService.getSeguro({
  //         loanId,
  //         estudianteId: cacheCredit.estudiante.id
  //       })
  //     .then((responseEstudent) => {
  //       if (responseEstudent.length > 0) {
          
  //       } else {
          
  //       }
  //       SeguroService.getSeguro({
  //         loanId,
  //         estudianteId: cacheCredit.estudiante.id
  //       })
  //     .then((response) => {
  //       setFormData(response);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       dialog.info(DIALOG.N11, {
  //         devInfo: error.message || error.code || error.type,
  //       });
  //     });
  //       setFormData(response);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       dialog.info(DIALOG.N11, {
  //         devInfo: error.message || error.code || error.type,
  //       });
  //     });

  useEffect(() => {
    if (cacheCredit) {
      fetchGetForm();
    }
  }, [cacheCredit]);

  useEffect(() => {
      const checkData = async () => {
        const name = await getNombreCompleto();
        if (name) {
          setNameUser(name[0]);
          setDocumentUser(getNombreCompleto()[1]);
          
        }
      };
      if (formStudent || formCodeudor1 || formCodeudor2) {
        checkData();
      }
    }, [formStudent, formCodeudor1, formCodeudor2]);

  return (
    <>
      <h1 className="text-center text-3xl font-bold">
        ¡Hola {user.given_name}{' '}
        <Emoji symbol="waving-hand-light-skin-tone" className="inline h-8" />
        <Emoji symbol="smiling-face-with-smiling-eyes" className="inline h-8" />
        <Emoji symbol="white-exclamation-mark" className="inline h-8" />
      </h1>
      <h1 className="text-center text-3xl font-bold">
        ¡Última etapa para terminar! 
        <Emoji symbol="party-popper" className="inline h-8" />
      </h1>
      <br />
      {loading ? (
        <Loading />
      ) : renderForm ? (
        <div className="space-y-4">
          <p className="font-bold text-center mb-3">
            ¡Necesitamos generar el seguro de vida de tu financiación!
          </p>
          <p className="">
            Es importante que respondas con total sinceridad a las siguientes preguntas, 
            para garantizar que tanto tú como tus codeudores queden debidamente protegidos ante 
            cualquier eventualidad de fallecimiento o invalides:
          </p>
          <br />
          <p className="font-bold text-[#E7496C] text-center">
            Esta pregunta es para:
          </p>
          <p className="font-bold text-center">
          { nameUser }
          </p>
          <p className="font-bold text-center">
            {documentUser}
          </p>
          <br />
          <FormProvider {...methods}>
            <SeguroFormIndex
              cacheCredit={cacheCredit}
              loanId={loanId}
              onSubmit={onSubmit}
              submit={submit}
            />
          </FormProvider>
          <div className="flex justify-center p-6">
            <div className="grid grid-cols-2 gap-4 lg:gap-6">
              <Link to="/solicitar-financiacion">
                <Button className="w-full" disabled={isSubmitting}>
                  {'<'} {RETURN}
                </Button>
              </Link>
              <Button
                className="w-full"
                onClick={() => setSubmit((current) => current + 1)}
                loading={isSubmitting}
              >
                Enviar {'>'}
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <>
          <p className="font-bold text-center mb-3">
            ¡Necesitamos generar el seguro de vida de tu financiación!
          </p>
          <p className="">
          Es importante que respondas con total sinceridad a las siguientes preguntas, 
          para garantizar que tanto tú como tus codeudores queden debidamente protegidos ante 
          cualquier eventualidad de fallecimiento o invalides:
          </p>
          <br />
          <p className="font-bold text-[#E7496C] text-center">
            Esta pregunta es para:
          </p>
          <br />
          <p className="font-bold text-center">
            { nameUser }
          </p>
          <p className="font-bold text-center">
          {documentUser}
          </p>
          <br />
          <p className='text-center'>
            ¿Padece alguna enfermedad crónica, condicionante, 
            <br /> 
            autoinmune, incapacitante o infecciosa, que requiere atención médica especial?
          </p>
          <div className="mt-4 flex justify-center space-x-4">
            <Button className="w-40"
            customColor="bg-custom-green"
            disabled={!loadingButton}
            onClick={() => {
              setRenderForm(false); 
              handleSubmit(onSubmit)();
              }
            }
            >
              No
            </Button>
            <Button
              customColor="bg-custom-green"
              className="w-40"
              loading={!loadingButton}
              onClick={() => 
                {
                  setRenderForm(true); 
                  setAceptedForm(true);
                }
              }
            >
              Sí
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default SeguroForm;
